// src/telemetry/queue/EventQueue.ts

import type {
  TelemetryEvent,
} from '../types/telemetry';

const STORAGE_KEY =
  '__telemetry_queue__';

export class EventQueue {

  private queue: TelemetryEvent[] = [];

  constructor() {
    this.restore();
  }

  add(event: TelemetryEvent) {

    this.queue.push(event);

    this.persist();
  }

  getAll() {
    return [...this.queue];
  }

  clear() {

    this.queue = [];

    localStorage.removeItem(
      STORAGE_KEY
    );
  }

  size() {
    return this.queue.length;
  }

  private persist() {

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(this.queue)
    );
  }

  private restore() {

    const raw =
      localStorage.getItem(
        STORAGE_KEY
      );

    if (!raw) return;

    try {

      this.queue =
        JSON.parse(raw);

    } catch {

      this.queue = [];

    }
  }

}

export const eventQueue =
  new EventQueue();